<template lang="pug">
  .home
    font-cursor
    section(@mouseenter="setCursor(1)")
      font-slider(:sliderClass="fontClass" color="black")
    section(@mouseenter="setCursor(2)")
      font-redactor(color="white")
      font-intro-mobile(color="white" v-if="getMobile")
    section(@mouseenter="setCursor(false)")
      font-detail(:class="styleClass" color="black")
    section(@mouseenter="setCursor(4)")
      font-draggable(color="white")
    section(@mouseenter="setCursor(5)")
      font-intro(color="black" v-if="!getMobile")
    section(@mouseenter="setCursor(6)")
      font-writer
    section(@mouseenter="setCursor(7)")
      font-download(color="black")
    section(@mouseenter="setCursor(8)")
      font-credits
</template>

<script>
import FontDraggable from "@/components/FontDraggable.vue";
import FontCredits from "@/components/FontCredits.vue";
import FontCursor from "@/components/FontCursor.vue";
import FontDetail from "@/components/FontDetail.vue";
import FontDownload from "@/components/FontDownload.vue";
import FontIntro from "@/components/FontIntro.vue";
import FontIntroMobile from "@/components/FontIntroMobile.vue";
import FontRedactor from "@/components/FontRedactor.vue";
import FontSlider from "@/components/FontSlider.vue";
import FontWriter from "@/components/FontWriter.vue";

import Utils from "@/mixins/utils.js";
import { mapActions, mapGetters } from 'vuex'

export default {
  name: "home",

  data() {
    return {
      colorClass: "black",
      detailLetter: "s",
      fontIndex: 0,
      styleIndex: 0,
      redactorIndex: 0,
      statement:
        "Redaction is a new typeface created as a typographic extension of the exhibition, made in collaboration with creative director Forest Young and type designer Jeremy Mickel. Redaction is meant to feel familiar, rooted in the history of Times New Roman and New Century Schoolbook as the de facto typefaces of legal documents in the United States. But the familiar has been abstracted and heightened — soft round forms are contrasted with razor-sharp terminals, a nod to the dichotomy of cruelty and kindness evident in the eagle grasping both arrows and an olive branch in the U.S. presidential seal. The letterforms also feature digital artifacts, or “notches”, in the joins of the letterforms, a reference to the distortion of documents that have been faxed or photocopied after passing through numerous hands and machines. Redaction is available in Regular, Bold, and Italic styles, as well as special bitmap versions that range from subtly analog to nearly illegible, an homage to the transformation and marginalization that many people face in the criminal justice system today."
    };
  },

  mixins: [Utils],

  components: {
    FontCursor,
    FontDraggable,
    FontCredits,
    FontDetail,
    FontDownload,
    FontIntro,
    FontIntroMobile,
    FontRedactor,
    FontSlider,
    FontWriter
  },

  created() {
    window.addEventListener("mousemove", this.mapXY);
    window.addEventListener("keydown", this.handleKeys);
    window.addEventListener("touchmove", this.handleTouchMove);
  },

  destroyed() {
    window.removeEventListener("mousemove", this.mapXY);
    window.removeEventListener("keydown", this.handleKeys);
    window.addEventListener("touchmove", this.handleTouchMove);
  },

  computed: {
    ...mapGetters({
      getMobile: 'getMobile'
    }),

    fontClass() {
      return "f-" + this.fontIndex;
    },

    styleClass() {
      return "fs-" + this.styleIndex;
    }
  },

  methods: {
    ...mapActions({
      setActiveLetter: 'setActiveLetter',
      setCursor: 'setCursor'
    }),

    handleKeys(e) {
      if (e.key.length === 1 && e.code !== "Space") {
        this.setActiveLetter(e.key);
      } else if (e.key === "ArrowLeft") {
        this.colorClass = "black";
      } else if (e.key === "ArrowRight") {
        this.colorClass = "white";
      } else if (e.code === "Space") {
        this.colorClass = this.colorClass === "white" ? "black" : "white";
      }
    },

    handleTouchMove(e) {
      e.preventDefault();
      const x = this.map(e.pageX, 0, window.innerWidth, 0, 7);
      this.fontIndex = Math.floor(x);
    },

    mapXY(e) {
      const width = window.innerWidth;
      const height = window.innerHeight;
      const sliderX = this.map(e.x, 0, width, 0, 7);
      const redactorX = this.map(e.x, 0, width, 0, 5);
      this.fontIndex = Math.floor(sliderX);
      this.redactorIndex = Math.floor(redactorX);
      const y = this.map(e.y, 0, height, 0, 3);
      this.styleIndex = Math.floor(y);
    }

    // track () {
    //   this.$ga.page('/')
    // }
  }
};
</script>

<style lang="sass">
  .home
    width: 100vw
    overflow-x: hidden
</style>
